import { gql } from "@apollo/client";

export default gql`
  query getGeneralDocs($start: Date, $end: Date, $search: String) {
    getGeneralDocs(start: $start, end: $end, search: $search) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        time
        title
        desc

        contractId
        contractName
        contractNameAr

        customerId
        customerName
        customerNameAr
        customerPhone

        supplierId
        supplierName
        supplierNameAr

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone

        resourseId
        resourseName
        resourseNameAr
        resourseColor

        stockId
        stockName
        stockNameAr

        refNo
        refType

        amount

        debitAcc
        debitAccName
        debitAccNameAr
        creditAcc
        creditAccName
        creditAccNameAr

        uploadId
        userId
        note

        attachments

        createdAt
        updatedAt
      }
    }
  }
`;
